import { useEffect } from "react";
import CareerBanner from "./BannerSection/CareerBanner";
import Benefits from "./Benefits/Benefits";
import OpenPositions from "./OpenPosition/OpenPositions";
import { Helmet } from "react-helmet-async";

function Career() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <>
      <Helmet>
        <title>Careers at Quad Theory Ltd | Build Software That Actually Matters</title>
        <meta
          name="description"
          content="Explore careers at Quad Theory Ltd and work on real world software projects. Join a collaborative team that values growth, ownership, flexibility, and building systems that make a real impact."
        />
      </Helmet>
      </>
      <CareerBanner />
      <Benefits />
      <OpenPositions />
    </div>
  );
}

export default Career;
